export default {
  LOADING: 'LOADING',
  LOADED: 'LOADED',

  SET_USER: 'SET_USER',
  SET_TOKEN: 'SET_TOKEN',
  SET_ERROR: 'SET_ERROR',

  SET_LOGIN: 'SET_LOGIN',
  SET_PROFILE: 'SET_PROFILE',
  SET_MENU: 'SET_MENU',
  SET_LOGOUT: 'SET_LOGOUT',

  SET_TITLE: 'SET_TITLE',

  GET_ALL_GROUP_SUCCESS: 'GET_ALL_GROUP_SUCCESS',
  GET_ALL_GROUP_FAILED: 'GET_ALL_GROUP_FAILED',

  GET_ALL_PERMISSION_SUCCESS: 'GET_ALL_PERMISSION_SUCCESS',
  GET_ALL_PERMISSION_FAILED: 'GET_ALL_PERMISSION_FAILED',

  GET_ALL_BRAND_SUCCESS: 'GET_ALL_BRAND_SUCCESS',
  GET_ALL_BRAND_FAILED: 'GET_ALL_BRAND_FAILED',
  GET_DETAIL_BRAND_SUCCESS: 'GET_DETAIL_BRAND_SUCCESS',
  GET_DETAIL_BRAND_FAILED: 'GET_DETAIL_BRAND_FAILED',
  UPDATE_BRAND_SUCCESS: 'UPDATE_BRAND_SUCCESS',
  UPDATE_BRAND_FAILED: 'UPDATE_BRAND_FAILED',

  UPDATE_ROLE_SUCCESS: 'UPDATE_ROLE_SUCCESS',
  UPDATE_ROLE_FAILED: 'UPDATE_ROLE_FAILED',

  SET_PREV_PAGE: 'SET_PREV_PAGE',
  RESET_PREV_PAGE: 'RESET_PREV_PAGE',
  SET_PREV_PERPAGE: 'SET_PREV_PERPAGE',
  RESET_PREV_PERPAGE: 'RESET_PREV_PERPAGE',

  SET_USER_ROLE: 'SET_USER_ROLE',

  SET_URLS: 'SET_URLS',
  SET_URL: 'SET_URL',

  SET_USER_MAPPING: 'SET_USER_MAPPING',
  SET_SSHCP_MAPPING: 'SET_SSHCP_MAPPING'
};

// export const SET_MEMBERS = "SET_MEMBERS";
// export const SET_MEMBER_DREAM_DETAIL = "SET_MEMBER_DREAM_DETAIL";
// export const SET_DREAM_CATEGORIES = 'SET_DREAM_CATEGORIES';
